module.exports = __webpack_public_path__ + "static/img/3.25a31ad6.jpg";